import { useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";

import {
  BlockBackground,
  ContentContainer,
  PaddingWrapper,
} from "./paragraph-picture-component-styles";

type Props = {
  children: React.ReactNode;
};
export default function ParagraphPicture(props: Props) {
  const {
    connectors: { connect },
    id,
  } = useNode();

  return (
    <BlockBackground ref={connect} id={id}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <ContentContainer>{props.children}</ContentContainer>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackground>
  );
}

ParagraphPicture.craft = {
  isCanvas: true,
  custom: {
    displayName: "Paragraph & Picture",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
